/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-lines */
import { FC } from 'react'
import { Box, Skeleton, Typography } from '@mui/material'
import { useI18n } from '@popety_io/popety-io-lib'
import { format, isValid, parse } from 'date-fns'

import { HeatingLabelRoot } from './HeatingAndHotWater.style'
import HeatingValueField from './HeatingValueField'

export interface IHeatingAndHotWaterValues {
  heatGenerator: string
  energySource: string
  informationSource: string
  updatedYear: string
}
export interface IHeatingAndHotWaterProps {
  title: string
  isLoading: boolean
  data: IHeatingAndHotWaterValues
}
const HeatingAndHotWater: FC<IHeatingAndHotWaterProps> = ({
  title,
  isLoading,
  data,
}) => {
  const { t } = useI18n()

  const { energySource, heatGenerator, informationSource, updatedYear } = data

  const formatIfValidDate = (
    dateString: string | undefined,
  ): string | undefined => {
    if (!dateString) {
      return undefined
    }
    const parsedDate = parse(dateString, 'yyyy-MM-dd', new Date())

    if (isValid(parsedDate)) {
      return format(parsedDate, 'MM/dd/yyyy')
    }

    return dateString
  }

  return (
    <Box>
      <Typography
        fontWeight={500}
        marginBottom="10px"
        color="#041725"
        fontSize="0.923rem"
      >
        {title}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <HeatingLabelRoot sx={{ flex: '0 0 200px' }}>
            {t('building.energy.heatGenerator')}
          </HeatingLabelRoot>
          {isLoading ? (
            <Skeleton variant="text" width={100} />
          ) : (
            <HeatingValueField value={heatGenerator} />
          )}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <HeatingLabelRoot sx={{ flex: '0 0 200px' }}>
            {t('building.energy.energySource')}
          </HeatingLabelRoot>
          {isLoading ? (
            <Skeleton variant="text" width={100} />
          ) : (
            <HeatingValueField value={energySource} />
          )}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <HeatingLabelRoot sx={{ flex: '0 0 200px' }}>
            {t('building.energy.informationSource')}
          </HeatingLabelRoot>
          {isLoading ? (
            <Skeleton variant="text" width={100} />
          ) : (
            <HeatingValueField value={informationSource} />
          )}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <HeatingLabelRoot sx={{ flex: '0 0 200px' }}>
            {t('building.energy.dateUpdated')}
          </HeatingLabelRoot>
          {isLoading ? (
            <Skeleton variant="text" width={100} />
          ) : (
            <HeatingValueField value={formatIfValidDate(updatedYear)} />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default HeatingAndHotWater
